import { render, staticRenderFns } from "./homeNotice.vue?vue&type=template&id=0094474c&scoped=true&"
import script from "./homeNotice.vue?vue&type=script&lang=js&"
export * from "./homeNotice.vue?vue&type=script&lang=js&"
import style0 from "./homeNotice.vue?vue&type=style&index=0&id=0094474c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094474c",
  null
  
)

export default component.exports